export default __webpack_public_path__ + "static/media/vip-bg.258b8a93.webp";